<!-- Header -->
<header id="main-header" class="header-main {{ classHeader ? 'header2' : '' }}">
    <div class="container container-header">
      <div class="row">
        <div class="col-sm-12">
            <nav class="navbar navbar-expand-lg navbar-light">
                <a class="navbar-brand" routerLink="">
                <img class="img-fluid logo" [src]="displayLogoImg || logoImg" alt="Qloud"/>
                </a>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="menu-btn d-inline-block" id="menu-btn" (click)="openMobileMenu()">
                    <span class="line"></span>
                    <span class="line"></span>
                    <span class="line"></span>
                </span>
                <span class="ion-navicon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav mr-auto w-100 left-sticky">
                        <li class="nav-item">
                            <a class="nav-link"  routerLink="" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">{{'MENU_HOME' | translate}}</a>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" routerLinkActive="active" id="navbarDropdown">{{'MENU_PRODUCTS' | translate}}</a>
                            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                                <!-- fullMode true -->
                                <!-- <a class="nav-link dropdown-item"  routerLink="/product/designer" routerLinkActive="active" id="navbarDropdown" *ngIf="fullModeService.fullMode">{{'DESIGNER' | translate}}</a> -->
                                <a class="nav-link dropdown-item"  routerLink="/product/creator" routerLinkActive="active" id="navbarDropdown">{{'PRODUCT_SYNC_CREATOR_MODE_TRUE' | translate}}</a>
                                 <!-- <a class="nav-link dropdown-item"  routerLink="/product/backoffice" routerLinkActive="active" id="navbarDropdown" *ngIf="fullModeService.fullMode">{{'BACKOFFICE' | translate}}</a> -->
                                 <!-- fullmode true + false  -->
                                 <!-- <a class="nav-link dropdown-item"  routerLink="/product/sync-api" routerLinkActive="active" id="navbarDropdown">{{'PRODUCT_SYNC_API' | translate}}</a> -->
                                <a class="nav-link dropdown-item"  routerLink="/downloads/se2sync-api" *ngIf="fullModeService.fullMode" routerLinkActive="active" id="navbarDropdown">{{'PRODUCT_SYNC_API' | translate}}</a>
                            </div>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle"  routerLinkActive="active" id="navbarDropdown">{{'MENU_SERVICES' | translate}}</a>
                            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                                <!-- fullMode true  -->
                                <a class="dropdown-item"   routerLink="/cloud-it-department" routerLinkActive="active" *ngIf="fullModeService.fullMode">{{'CLOUD_IT_DEPARTMENT' | translate}}</a>
                                <!-- united mode -->
                                <a class="dropdown-item"   routerLink="/cluster-hosting" routerLinkActive="active">{{'DATABASE_HOSTING' | translate}}</a>
                                <a class="dropdown-item"   routerLink="/database-migration" *ngIf="!fullModeService.fullMode" routerLinkActive="active">{{'MIGRATION' | translate}}</a>
                            </div>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" routerLinkActive="active" id="navbarDropdown">{{'DOWNLOADS' | translate}}</a>
                            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                                <!-- full mode true -->
                               <!--  <a class="nav-link dropdown-item"  routerLink="/downloads/designer" routerLinkActive="active" id="navbarDropdown" *ngIf="fullModeService.fullMode">{{'DESIGNER' | translate}}</a> -->
                                <a class="nav-link dropdown-item"  routerLink="/downloads/se2sync-creator" routerLinkActive="active" id="navbarDropdown" *ngIf="fullModeService.fullMode">{{'PRODUCT_SYNC_CREATOR_MODE_TRUE' | translate}}</a>
                                <!-- <a class="nav-link dropdown-item"  routerLink="/downloads/backoffice" routerLinkActive="active" id="navbarDropdown" *ngIf="fullModeService.fullMode">{{'BACKOFFICE' | translate}}</a> -->
                                <a class="nav-link dropdown-item"  routerLink="/downloads/se2sync-creator" routerLinkActive="active" id="navbarDropdown" *ngIf="!fullModeService.fullMode">{{'PRODUCT_SYNC_CREATOR_MODE_FALSE' | translate}}</a>
                                <a class="nav-link dropdown-item"  routerLink="/downloads/se2sync-api" routerLinkActive="active" id="navbarDropdown" *ngIf="fullModeService.fullMode">{{'PRODUCT_SYNC_API' | translate}}</a>
                            </div>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" routerLinkActive="active" id="navbarDropdown">{{'PRICING' | translate}}</a>
                            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                                <!-- fullmode true -->
                                <a class="dropdown-item"   routerLink="/pricing-plan/cloud-it-department"  routerLinkActive="active" *ngIf="fullModeService.fullMode">{{'CLOUD_IT_DEPARTMENT' | translate}}</a>
                                <!--  united -->
                                <a class="dropdown-item"   routerLink="/pricing-plan/cluster-hosting"  routerLinkActive="active">{{'DATABASE_HOSTING' | translate}}</a>
                                <!--<a class="dropdown-item"   routerLink="/pricing-plan/migration"  routerLinkActive="active" >{{'MIGRATION' | translate}}</a>-->
                                <!-- <a class="dropdown-item"   routerLink="/pricing-plan/se2sync-api"  routerLinkActive="active" >{{'PRODUCT_SYNC_API' | translate}}</a> -->
                                <!-- false -->
                            </div>
                        </li>
                        <li class="nav-item" >
                            <a class="nav-link dropdown-toggle"  routerLink="/contact-us" routerLinkActive="active">{{'MENU_CONTACT' | translate}}</a>
                        </li>
                        <!-- for mobile -->
                        <li class="nav-item mobile">
                            <a class="nav-link dropdown-toggle dropdown-toggle-lang" title="{{ 'SETTINGS_LANGUAGE' | translate }}" style="margin-right: 18px;">
                                <i class="flag-icon flag-icon-de" *ngIf="langService.activeLanguage === 'de'"></i>
                                <i class="flag-icon flag-icon-us" *ngIf="langService.activeLanguage === 'en'"></i>
                                <i class="flag-icon flag-icon-it" *ngIf="langService.activeLanguage === 'it'"></i>
                                <i class="flag-icon flag-icon-es" *ngIf="langService.activeLanguage === 'es'"></i>
                                <i class="flag-icon flag-icon-fr" *ngIf="langService.activeLanguage === 'fr'"></i>
                            </a>
                            <ul class="dropdown-menu dropdown-lang">
                                <li class="nav-item" (click)="onChangeLand('de')">
                                    <i class="flag-icon flag-icon-de"></i>
                                    <span class="lang-txt">Deutsch</span>
                                </li>
                                <li class="nav-item" (click)="onChangeLand('en')">
                                    <i class="flag-icon flag-icon-us"></i>
                                    <span class="lang-txt">English</span>
                                </li>
                                <li class="nav-item" (click)="onChangeLand('it')">
                                    <i class="flag-icon flag-icon-it"></i>
                                    <span class="lang-txt">Italiano</span>
                                </li>
                                <li class="nav-item" (click)="onChangeLand('es')">
                                    <i class="flag-icon flag-icon-es"></i>
                                    <span class="lang-txt">Español</span>
                                </li>
                                <li class="nav-item" (click)="onChangeLand('fr')">
                                    <i class="flag-icon flag-icon-fr"></i>
                                    <span class="lang-txt">Français</span>
                                </li>
                            </ul>
                        </li>
                        <!-- <li class="d-inline mobile"><a class="login iq-button iq-btn-outline iq-btn-round" target="_blank">Login</a></li> -->
                    </ul>
                    <ul class="navbar-nav right-sticky desktop">
                        <li class="nav-item">
                            <a class="nav-link dropdown-toggle dropdown-toggle-lang" title="{{ 'SETTINGS_LANGUAGE' | translate }}" style="margin-right: 18px;">
                                <span class="fi fi-de" *ngIf="langService.activeLanguage === 'de'"></span>
                                <span class="fi fi-us" *ngIf="langService.activeLanguage === 'en'"></span>
                                <span class="fi fi-it" *ngIf="langService.activeLanguage === 'it'"></span>
                                <span class="fi fi-es" *ngIf="langService.activeLanguage === 'es'"></span>
                                <span class="fi fi-fr" *ngIf="langService.activeLanguage === 'fr'"></span>
                            </a>
                            <ul class="dropdown-menu dropdown-lang">
                                <li class="nav-item" (click)="onChangeLand('de')">
                                    <span class="fi fi-de"></span>
                                    <span class="lang-txt">Deutsch</span>
                                </li>
                                <li class="nav-item" (click)="onChangeLand('en')">
                                    <span class="fi fi-us"></span>
                                    <span class="lang-txt">English</span>
                                </li>
                                <li class="nav-item" (click)="onChangeLand('it')">
                                    <span class="fi fi-it"></span>
                                    <span class="lang-txt">Italiano</span>
                                </li>
                                <li class="nav-item" (click)="onChangeLand('es')">
                                    <span class="fi fi-es"></span>
                                    <span class="lang-txt">Español</span>
                                </li>
                                <li class="nav-item" (click)="onChangeLand('fr')">
                                    <span class="fi fi-fr"></span>
                                    <span class="lang-txt">Français</span>
                                </li>
                            </ul>
                        </li>
                        <a class="ticket-icon" href="mailto:support@se2.tech"
                            matTooltip="{{'SUPPORT_TICKET' | translate}}"
                            matTooltipPosition="below"
                        >
                            <img src="../../../assets/images/se-icons/ticket.png">
                        </a>
                         <a class="ticket-icon" href="mailto:info@se2.tech"
                            matTooltip="{{'SEND_MAIL' | translate}}"
                            matTooltipPosition="below"
                        >
                            <img src="../../../assets/images/se-icons/mail.png">
                        </a>
                        <a class = "user-icon" (click)="redirectToCreator()"
                            matTooltip="{{'MY_PROFILE' | translate}}"
                            matTooltipPosition="below"
                            style="margin-right: 18px;"
                        >
                            <img src="../../../assets/images/se-icons/profiles.svg">
                        </a>
                        <a class = "ticket-icon" (click)="logout()"
                            matTooltip="{{'LOGOUT' | translate}}"
                            matTooltipPosition="below"
                            *ngIf="isLoggedIn"
                            style="margin-right: 0px;"
                        >
                            <img src="../../../assets/images/se-icons/logout.png">
                        </a>
                        <!-- isLoggedIn -->
                        <!-- <li class="d-inline"><a routerLink="/login"  id ="login" class="login iq-button iq-btn-outline iq-btn-round" *ngIf="!isLoggedIn">Login</a></li>
                        <li class="d-inline"><a (click)="logout()" id ="logout" class="login iq-button iq-btn-outline iq-btn-round" *ngIf="isLoggedIn">Logout</a></li> -->
                    </ul>
                </div>
            </nav>
        </div>
      </div>
    </div>
  </header>
<!-- Header End -->
